import jwt_decode from "jwt-decode";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const getCookie = (cname) => {
  // Tentar com react-cookie primeiro
  const cookieValue = cookies.get(cname);
  if (cookieValue) {
    return cookieValue;
  }

  // Fallback: ler diretamente do document.cookie
  if (typeof document !== 'undefined') {
    const value = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${cname}=`));
    if (value) {
      return value.split('=')[1];
    }
  }

  return "";
};

export const getItemLocalStorage = (cname) => {
  return window.localStorage.getItem(cname) || "";
};

export const setCookie = async (cname, value, options = {}) => {
  const hostname = window.location.hostname;
  let domain;

  if (hostname.includes("localhost") || hostname === "127.0.0.1") {
    domain = hostname;
  } else if (hostname.includes("paradigma.education")) {
    domain = ".paradigma.education";
  } else if (hostname.match(/^192\.168\.\d+\.\d+$/) || hostname.match(/^10\.\d+\.\d+\.\d+$/)) {
    // IPs de rede local (192.168.x.x ou 10.x.x.x)
    domain = hostname;
  } else {
    // Para outros domínios, não definir domínio específico
    domain = undefined;
  }

  const cookieOptions = {
    path: "/",
    expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
    ...options,
  };

  if (domain) {
    cookieOptions.domain = domain;
  }

  cookies.set(cname, value, cookieOptions);
};

export const setItemLocalStorage = async (cname, value) => {
  window.localStorage.setItem(cname, value);
};

export const deleteCookie = async (cname, domain) => {
  const hostname = window.location.hostname;
  let cookieDomain;

  if (hostname.includes("localhost") || hostname === "127.0.0.1") {
    cookieDomain = hostname;
  } else if (hostname.includes("paradigma.education")) {
    cookieDomain = ".paradigma.education";
  } else if (hostname.match(/^192\.168\.\d+\.\d+$/) || hostname.match(/^10\.\d+\.\d+\.\d+$/)) {
    // IPs de rede local (192.168.x.x ou 10.x.x.x)
    cookieDomain = hostname;
  } else {
    cookieDomain = undefined;
  }

  const removeOptions = {
    path: "/",
    maxAge: 0,
  };

  if (cookieDomain) {
    removeOptions.domain = cookieDomain;
  }

  cookies.remove(cname, removeOptions);
};

export const deleteItemLocalStorage = async (cname, domain) => {
  window.localStorage.removeItem(cname);
  document.cookie = cname + "=; Max-Age=-99999999;";
  return;
};

export const getObjectFromCookie = (cname, type) => {
  const obj = getCookie(cname);

  if (obj === "") {
    return null;
  }

  if (obj === "undefined") {
    return null;
  }

  if (obj) {
    const obj_parsed = obj;
    return obj_parsed;
  }

  return null;
};

export const getObjectFromLocalStorage = (cname) => {
  const obj = window.localStorage.getItem(cname);

  if (obj === "") {
    return null;
  }

  if (obj === "undefined") {
    return null;
  }

  if (obj) {
    const obj_parsed = obj;
    return obj_parsed;
  }

  return null;
};

export const decodeObjFromCookie = (cname) => {
  const obj = getCookie(cname);

  if (obj) {
    const obj_parsed = jwt_decode(obj);
    return obj_parsed;
  }

  return null;
};

export const decodeObjFromLocalStorage = (cname) => {
  const obj = window.localStorage.getItem(cname);

  if (obj) {
    const obj_parsed = jwt_decode(obj);
    return obj_parsed;
  }

  return null;
};

export const getUserDetailsFromCookie = () => {
  const session = getCookie("_session");

  if (session && session !== "undefined") {
    const sessionRet = jwt_decode(session);
    return sessionRet;
  }

  return null;
};

export const getTokenFromCookie = () => {
  const session = getCookie("_session");

  if (session) {
    const sessionRet = session;
    return sessionRet;
  }

  return null;
};

export const checkTokenExpiration = () => {
  const token = getTokenFromCookie();

  if (!token) {
    return true; // Token não existe, considerado expirado
  }

  try {
    const decodedToken = jwt_decode(token);

    if (!decodedToken.exp) {
      return true; // Token sem expiração, considerado inválido
    }

    const currentTime = Date.now() / 1000;
    return decodedToken.exp < currentTime; // true se expirado, false se válido
  } catch (error) {
    console.error("Erro ao decodificar token:", error);
    return true; // Erro na decodificação, considerado expirado
  }
};
